import React from "react";
import NotesList from "../../Components/NotesItems/NotesList/NotesList";
import "./Notes.scss";

const Notes = () => {
  return <NotesList />;
};

export default Notes;
